import { useClientTerminology } from '@/hooks/useClientTerminology';
import { ButtonComponent } from '@/components/Button/Button';
import classes from './SearchBar.module.css';

export const NoSuggestions = ({
  hasFilters = false,
  onClearFilter,
}: {
  hasFilters?: boolean;
  onClearFilter?: () => void;
}) => {
  const intl = useClientTerminology();

  return (
    <div className={classes.noSuggestions} data-testid="search-bar-no-options">
      {intl.formatMessage({
        id: hasFilters
          ? 'search.noResultsWithActiveFilters'
          : 'search.noResults',
      })}
      {hasFilters && onClearFilter && (
        <span data-testid="search-bar-clear-filter">
          <ButtonComponent
            variant="secondary"
            label={intl.formatMessage({ id: 'search.clearFilterButton' })}
            onClick={onClearFilter}
          />
        </span>
      )}
    </div>
  );
};
